import { SET_LOCALE_STATE, SET_LOCALE, SET_LOCALE_DEVTOOL, SET_LOCALE_START, SET_LOCALE_SUCCESS, SET_LOCALE_ERROR, UPDATE_NON_TRANSLATABLE_RESOURCE_STRINGS, } from './constants.js';
/**
 * This is static cache singleton.
 * It's not needed to keep all locales in redux store
 * It's here to prevent async load code path if language is already loaded
 */
export const localeMessagesCache = new Map();
let config = null;
/**
 * Get global locale configuration
 */
function getLocaleConfig() {
    if (!config) {
        throw new Error('Locale is not configured');
    }
    return config;
}
export const configureLocale = (localeConfig) => {
    const { supported, loader } = localeConfig;
    if (!loader || !supported || !supported[0]) {
        throw new Error('configureLocale must be called with loader and at least one value in supported array');
    }
    config = {
        supported,
        loader,
        default: localeConfig.default ?? supported[0],
        source: localeConfig.source ?? supported[0],
    };
    return { type: SET_LOCALE_STATE, payload: config };
};
/**
 * Synchronous method how to manually set and activate dictionary.
 * Skips cache
 */
export const actionSetLocale = (payload) => {
    localeMessagesCache.set(payload.locale, payload.messages);
    return {
        type: SET_LOCALE,
        payload,
    };
};
const actionSetLocaleStart = (payload) => ({
    type: SET_LOCALE_START,
    payload,
});
const actionSetLocaleSuccess = (payload) => ({
    type: SET_LOCALE_SUCCESS,
    payload,
});
const actionSetLocaleError = (error) => ({
    type: SET_LOCALE_ERROR,
    payload: error,
    error: true,
});
export const setLocale = (locale) => async (dispatch) => {
    const messages = localeMessagesCache.get(locale);
    if (messages) {
        return dispatch(actionSetLocale({ locale, messages }));
    }
    // TODO double true in configuration and reducer for supported languages
    const { supported, loader } = getLocaleConfig();
    if (!supported.includes(locale)) {
        return dispatch(actionSetLocaleError(new Error(`Locale '${locale}' is not supported`)));
    }
    dispatch(actionSetLocaleStart(locale));
    try {
        const messages = await loader(locale);
        localeMessagesCache.set(locale, messages);
        return dispatch(actionSetLocaleSuccess({ locale, messages }));
    }
    catch (err) {
        return dispatch(actionSetLocaleError(err));
    }
};
export const actionSetLocaleDevtool = (payload) => ({
    type: SET_LOCALE_DEVTOOL,
    payload,
});
export const actionUpdateNonTranslatableResourceStrings = (payload) => ({
    type: UPDATE_NON_TRANSLATABLE_RESOURCE_STRINGS,
    payload,
});
//# sourceMappingURL=actions.js.map